<template>
  <main class="h-screen overflow-x-hidden">
    <slot />
  </main>
  <CustomToast v-if="toastStore.messages.length > 0" />
</template>

<script setup lang="ts">
import CustomToast from '../components/shared/CustomToast/CustomToast.vue'
import { useToastStore } from '../store'

defineOptions({
  name: 'TheAuthLayout',
})

const toastStore = useToastStore()
</script>
